import Questionaire from './Questionaire'

export default Questionaire
